import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);

  return (
    <div data-testid="page-blog" className="bg-[#F9F8F6]">
      <section className="container-editorial pt-16 md:pt-24 pb-16">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-[80px] tracking-tight leading-[1] max-w-4xl">Notes on material, warmth and the making of quiet interiors.</h1>
      </section>

      <section className="container-editorial pb-24 overflow-hidden">
        <div className="grid grid-cols-12 gap-x-8 gap-y-16 border-t border-[#D5D0C8] pt-14">
          {posts.map((post, i) => (
            <article key={post.id} data-testid={`blog-card-${i}`} className={i === 0 ? "col-span-12 lg:col-span-8" : "col-span-12 md:col-span-6 lg:col-span-4"}>
              <Link to={`/blog/${post.slug}`} className="group block">
                <div className={`overflow-hidden rounded-sm ${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                  <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
                </div>
                <div className="mt-6">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-[#A85C42]">{post.category}</div>
                  <h2 className={`font-serif tracking-tight mt-2 ${i === 0 ? "text-4xl md:text-5xl" : "text-2xl md:text-3xl"}`}>{post.title}</h2>
                  <p className="mt-3 text-[#4A4642] leading-relaxed">{post.excerpt}</p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
